module.exports = __webpack_public_path__ + "static/media/KP.526d9fce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KP.svg
// module id = 2188
// module chunks = 7